<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="pieOptions" @click="languageFilter" style='width: 100%; height: 100%' ref="pie" auto-resize v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      languages: [],
      pieOptions: {
        tooltip: {trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)'},
        series: [{
          name: 'Languages',
          type: 'pie',
          data: [
            {value: 0, name: ''}
          ]
        }]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getLanguageId', 'getQuery']),
    filterLanguage: function () {
      return this.getLanguageId
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters', 'resetLanguageFilter']),
    languageFilter: function (type) {
      var languageId = this.languages.find(obj => { return obj.name === type.name }).id
      var filter = this.filterLanguage.slice()
      var index = filter.indexOf(languageId)
      if (index >= 0) {
        filter.splice(index, 1)
        this.setCustomFilters({languageId: filter})
      } else {
        filter.push(languageId)
        this.setCustomFilters({languageId: filter})
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweetsByLanguages', this.getQuery({sortBy: '_tweet_count', order: 'desc', pageSize: 25}))
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.languages = []
          this.pieOptions.series = []

          var temp = []
          for (var i = 0; i < response.data.payload.length; i++) {
            temp.push({value: response.data.payload[i]._tweet_count, name: response.data.payload[i]._language_name})
            this.languages.push({id: response.data.payload[i]._language_id, name: response.data.payload[i]._language_name})
          }

          this.pieOptions.series.push({
            name: 'Languages',
            type: 'pie',
            data: temp
          })

          if (temp.length === 0) {
            this.dataState = 'noData'
          } else {
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let pie = this.$refs.pie
          if (pie) {
            pie.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let pie = this.$refs.pie
          if (pie) {
            pie.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/TweetsLanguagePieChart.vue